var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.10249 8.09524H9.30748V9.71429H3.10249V8.09524ZM4.65374 14.5714H1.55125V1.61905H6.98061V5.66667H10.8587V8.17619L12.41 6.55714V4.85714L7.75623 0H1.55125C1.13983 0 0.745265 0.170578 0.45435 0.474208C0.163434 0.777838 0 1.18965 0 1.61905V14.5714C0 15.0008 0.163434 15.4126 0.45435 15.7163C0.745265 16.0199 1.13983 16.1905 1.55125 16.1905H4.65374V14.5714ZM3.10249 12.9524H6.28255L6.98061 12.2238V11.3333H3.10249V12.9524ZM12.5651 8.90476C12.6427 8.90476 12.7978 8.98571 12.8753 9.06667L13.8837 10.119C14.0388 10.281 14.0388 10.6048 13.8837 10.7667L13.108 11.5762L11.4792 9.87619L12.2548 9.06667C12.3324 8.98571 12.41 8.90476 12.5651 8.90476ZM12.5651 12.0619L7.8338 17H6.20499V15.3L10.9363 10.3619L12.5651 12.0619Z",
    fill: "#D61D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/noteIcon.b9ff93c3852f109b68972e26ff45ef63.svg";
export { ForwardRef as ReactComponent };